import styled from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  layout,
  lineHeight,
  media,
  neutral,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import ProfileImageComponent from '../../common/ProfileImage';
import * as CommonCards from '../../common/elements/Cards';
import { Button } from '../../common/elements/Form';

export const ProfileImage = styled(ProfileImageComponent)`
  /* avatar size */
  height: 9.6rem;
  margin-top: ${space[5]};
`;

export const EditUserProfile = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space[3]};
  width: 100%;
  padding-bottom: ${space[7]};
`;

export const UploadButton = styled(Button).attrs(() => ({ as: 'label' }))``;

export const ImageInput = styled.input`
  display: none;
`;

export const DisplayName = styled.h1`
  margin: ${space[2]} 0 0;
  padding: 0 ${layout.gutter};
  color: ${({ theme }) => theme.headerColour};
  text-align: center;
  font-weight: ${fontWeight.heavy};
  font-size: ${fontSize.xxl};
  line-height: ${lineHeight.tight};
  overflow-wrap: anywhere;

  ${media.md`
    font-size: ${fontSize.display};
  `}
`;

export const LogoutButton = styled(Button)`
  margin-bottom: ${space[4]};
`;

export const ClassroomHeader = styled.h2`
  margin: 0;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.tight};
  overflow-wrap: anywhere;

  ${media.md`
    font-size: ${fontSize.xxl};
  `}
`;

export const ProfileCardList = styled(CommonCards.CardList)`
  width: 100%;

  ${media.md`
    max-width: ${layout.readableMaxWidth};
  `}
`;

export const PreferencesSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space[2]};
  width: calc(100% - 2 * ${layout.gutter});
  max-width: ${layout.readableMaxWidth};
  margin: ${space[3]} 0;
  padding: ${space[4]};
  border: 1px solid ${neutral.border};
  border-radius: ${radius.lg};
  background: ${neutral.surface};
  box-shadow: ${shadow.sm};
`;

export * from '../../common/elements/Cards';
export * from '../../common/elements/Form';
export * from '../../common/elements/Students';
